import { useEffect } from "react";

/**
 * Fix for KendoReact Grid Group Panel drag-drop on touch devices (v10.x).
 * Converts touch events into mouse events so the first drag works.
 */
export function useKendoGridTouchDragFix(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const panel = document.querySelector(".k-grouping-header");
    if (!panel) return;

    const touchHandler = (e) => {
      if (!e.changedTouches || e.changedTouches.length === 0) return;

      const touch = e.changedTouches[0];
      const eventType =
        e.type === "touchstart"
          ? "mousedown"
          : e.type === "touchmove"
          ? "mousemove"
          : e.type === "touchend"
          ? "mouseup"
          : null;

      if (!eventType) return;

      const mouseEvent = new MouseEvent(eventType, {
        bubbles: true,
        cancelable: true,
        view: window,
        clientX: touch.clientX,
        clientY: touch.clientY,
      });

      e.target.dispatchEvent(mouseEvent);
      e.preventDefault(); // important: stops scrolling instead of dragging
    };

    panel.addEventListener("touchstart", touchHandler, { passive: false });
    panel.addEventListener("touchmove", touchHandler, { passive: false });
    panel.addEventListener("touchend", touchHandler, { passive: false });

    return () => {
      panel.removeEventListener("touchstart", touchHandler);
      panel.removeEventListener("touchmove", touchHandler);
      panel.removeEventListener("touchend", touchHandler);
    };
  }, [enabled]);
}
